export default __webpack_public_path__ + "static/media/african-farming-operations-image.d97d16ca.jpg";